import script from "./ChartLegend.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChartLegend.vue?vue&type=script&setup=true&lang=ts"

import "./ChartLegend.vue?vue&type=style&index=0&id=6c163473&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c163473"]])

export default __exports__